import WebChatConfigurationEx from '../models/WebChatConfigurationEx';

export async function fetchWebChatConfiguration(id: string): Promise<WebChatConfigurationEx> {
	console.debug(`fetching web chat configuration`);
	const response = await fetch(`api/webchat/${id}`);
	if (!response.ok) {
		throw Error(response.statusText);
	}
    return response.json();
}